export const isAuthorized = (userRoles, roles) =>
  roles.some(role => userRoles.includes(role));

export const hasPermission = (userPerms, perm) =>
  userPerms.includes('ADMIN') || userPerms.includes(perm);
